import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { variantsQueryOptions } from '../../../../-hooks/useVariantsQuery';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(list)/variants/active/',
)({
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      variantsQueryOptions({ ...deps, isArchived: false }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/VariantsTab'),
    'VariantsTab',
  ),
});
